import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserInfo } from '../types/common';
import { logoutApi } from '@/api/modules/auth/logout';

/**
 * 用户状态接口
 */
export interface UserState {
  userInfo: UserInfo | null;
  token: string | null;
  setUserInfo: (info: UserInfo) => void;
  setToken: (token: string) => void;
  clearUser: () => void;
}

/**
 * 用户状态管理 Store
 * 使用 Zustand 创建轻量级状态管理
 * 支持状态持久化到 localStorage
 */
export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      // 初始状态
      userInfo: {
        userId: '-1',
        phone: '18612349817',
        username: '游客',
        email: 'lightx@hklspower.com',
        avatarUrl: '',
        role: {
          roleId: '-1',
          roleKey: 'guest',
          roleType: '1',
          roleName: '游客',
          permIds: [],
        },
        clientId: '',
        permissionCodes: [],
      },
      token: '123',

      // 设置用户信息
      setUserInfo: (info: UserInfo) => {
        set({ userInfo: info });
      },

      // 设置 token
      setToken: (token: string) => {
        set({ token });
      },

      // 清除用户信息（用于退出登录）
      clearUser: () => {
        set({ userInfo: null, token: null });
      },
    }),
    {
      name: 'user-storage', // localStorage 中的 key
      version: 1,
      // 可选：自定义存储方式
      // storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export const getAuthToken = () => useUserStore.getState().token;

export const logout = () => {
  logoutApi();
  useUserStore.getState().clearUser();
};
